"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Markdown = void 0;
const DOMPurify = require("dompurify");
const marked_1 = require("marked");
class Markdown {
    static render(text) {
        Markdown.installHooks();
        const html = marked_1.marked.parse(text !== null && text !== void 0 ? text : "", { gfm: true, breaks: true, async: false });
        return DOMPurify.sanitize(html, { USE_PROFILES: { html: true } });
    }
    static installHooks() {
        if (Markdown.hooked === true) {
            return;
        }
        DOMPurify.addHook("afterSanitizeAttributes", function (node) {
            if (node.tagName === "A" && node.hasAttribute("href") === true) {
                node.setAttribute("target", "_blank");
                node.setAttribute("rel", "noopener noreferrer");
            }
        });
        Markdown.hooked = true;
    }
}
exports.Markdown = Markdown;
Markdown.hooked = false;
